export function allIds(state, action) {
  const { design } = action.payload;

  if (state.indexOf(design.designId) > -1) {
    return state;
  }
  return [...state, design.designId];
}

export function byId(state, action) {
  const { design } = action.payload;

  const updatedbyId = { [design.designId]: design };
  return { ...state, ...updatedbyId };
}
